import React, { useMemo } from "react";
import { Link } from "gatsby";
import pages from "../../pages";
import { Box, Stack, Typography } from "@mui/material";

const LinkHandler = ({ caption, link }) => {
  const url = useMemo(() => {
    if (link.link_type !== "Document") return null;

    const urlKey = link.document[0].uid;

    return pages.find((item) => item.url(item.name === urlKey));
  }, [link]);

  return link ? (
    <Box
      component={link.link_type === "Document" ? Link : "a"}
      to={link.link_type === "Document" ? url.url : undefined}
      href={link.link_type === "Web" ? link.url : undefined}
      target={link.link_type === "Web" ? link.target : undefined}
      sx={{
        textDecoration: "none",
        flexShrink: 0,
        mr: "10px",
      }}
    >
      <Stack
        sx={{
          height: "36px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: { xs: "24px", sm: "32px" },
          borderRadius: "21px",
          border: `solid 2px #ffffff`,
          color: "#ffffff",
          backgroundColor: "#fd4b68",
          "&:hover": {
            color: "#fd4b68",
            backgroundColor: "#ffffff",
          },
        }}
      >
        <Typography
          sx={{
            fontWeight: 700,
            textAlign: "center",
            textTransform: "uppercase",
            fontSize: { xs: "10px", sm: "12px" },
          }}
        >
          {caption.text}
        </Typography>
      </Stack>
    </Box>
  ) : (
    <></>
  );
};

export default LinkHandler;
